module.exports = __webpack_public_path__ + "static/media/generic.169838cb.png";